<template>
    <div class="row">
        <div class="row" style="padding-top: 10px">
            <div class="col s2 offset-s5">
                <img src="../../assets/svg/ads-svgrepo-com.svg" class="responsive-img" alt="">
            </div>
        </div>
        <br>
        <h4 class="center-align">Circular de Ofertas</h4>
        <br>
        <form class="col s12" v-on:submit.prevent="onSubmit">
            <div class="row">
                <div class="input-field col s4 offset-s4">
                    <input type="email" v-model="user.email">
                    <label>E-mail</label>
                </div>
            </div>
            <div class="row">
                <div class="input-field col s4 offset-s4">
                    <input type="password" v-model="user.password">
                    <label>Senha</label>
                </div>
            </div>
            <div class="row">
                <div class="col s4 offset-s5">
                    <p>
                        <label>
                            <input type="checkbox" v-model="rememberEmail" />
                            <span>Lembrar meu e-mail</span>
                        </label>
                    </p>
                </div>
            </div>

            <div class="row">
                <button class="col s2 offset-s5 waves-effect waves-light btn" name="submit">entrar</button>
            </div>
        </form>
    </div>
</template>

<script>
import { BASE_URL_API } from '../../config.js';

export default {
    name: 'login',

    mounted() {
        const email = window.localStorage.getItem("user-email");
        if (email) {
            this.rememberEmail = true;

            this.user.email = email;
        }
    },

    methods: {
        onSubmit(e) {
            e.preventDefault();

            this.$http.post(BASE_URL_API + '/auth/login', this.user).then(response => {
                response.json().then(json => {
                    window.localStorage.setItem('user-token', json.token);

                    if (this.rememberEmail) {
                        window.localStorage.setItem('user-email', this.user.email);
                    }

                    this.$router.push('/');
                });
            }, response => {
                // error callback
                alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.')
            });
        }
    },

    data () {
        return {
            user: {
                email: '',
                password: ''
            },
            rememberEmail: false
        }
    }   
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/login/Login.vue